module.exports = __webpack_public_path__ + "img/iphone-charging-FRANCE-en.e348fb5f.webp";